module.exports = __webpack_public_path__ + "img/preview.95f96520.jpg";